var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipvertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.678,
    height: 20.384,
    viewBox: "0 0 16.678 20.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-flip",
    "data-name": "Icon material-flip",
    d: "M15.618,20.031h1.853V18.178H15.618ZM19.325,8.912h1.853V7.059H19.325ZM4.5,5.206V18.178a1.859,1.859,0,0,0,1.853,1.853h3.706V18.178H6.353V5.206h3.706V3.353H6.353A1.859,1.859,0,0,0,4.5,5.206ZM19.325,3.353V5.206h1.853A1.859,1.859,0,0,0,19.325,3.353ZM11.912,21.884h1.853V1.5H11.912Zm7.412-5.559h1.853V14.472H19.325ZM15.618,5.206h1.853V3.353H15.618Zm3.706,7.412h1.853V10.765H19.325Zm0,7.412a1.859,1.859,0,0,0,1.853-1.853H19.325Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#c4c4c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipvertical);
export default __webpack_public_path__ + "static/media/flipvertical.b7c800923bcad3c92aacaf2306246d19.svg";
export { ForwardRef as ReactComponent };